import { render } from "./Livescoring.vue?vue&type=template&id=0a47caf4&scoped=true"
import script from "./Livescoring.vue?vue&type=script&lang=js"
export * from "./Livescoring.vue?vue&type=script&lang=js"

import "./Livescoring.vue?vue&type=style&index=0&id=0a47caf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a47caf4"]])

export default __exports__